/**
 * @generated SignedSource<<e49a0d171cf204c0b601fbf996d84ae3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraRemoteLinkedIssueErrorType = "APPLINK_MISSING" | "APPLINK_REQ_AUTH" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type remoteIssueErrorRow_nativeIssueTable$data = {
  readonly errorType: JiraRemoteLinkedIssueErrorType | null | undefined;
  readonly repairLink: {
    readonly href: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "remoteIssueErrorRow_nativeIssueTable";
};
export type remoteIssueErrorRow_nativeIssueTable$key = {
  readonly " $data"?: remoteIssueErrorRow_nativeIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"remoteIssueErrorRow_nativeIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "remoteIssueErrorRow_nativeIssueTable",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "errorType"
    },
    {
      "concreteType": "JiraRemoteLinkedIssueRepairLink",
      "kind": "LinkedField",
      "name": "repairLink",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "href"
        }
      ]
    }
  ],
  "type": "JiraRemoteLinkedIssueError"
};

(node as any).hash = "4b0b11002505554c4dfc4885dad1c880";

export default node;
